import { emailInputValidationSchema } from "@jsq/ds/forms";
import { object, string } from "yup";

export const schema = object({
  email: emailInputValidationSchema({ isRequired: true }),
  password: string().required("Please enter your password"),
});
